import { render, staticRenderFns } from "./PesquisaInteligente.vue?vue&type=template&id=ce65cfa2&scoped=true&lang=pug"
import script from "./PesquisaInteligente.vue?vue&type=script&lang=js"
export * from "./PesquisaInteligente.vue?vue&type=script&lang=js"
import style0 from "./PesquisaInteligente.vue?vue&type=style&index=0&id=ce65cfa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce65cfa2",
  null
  
)

export default component.exports